import React, { useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./homeBanner.css";
import { isMobile } from "../../../utils/commonMethods";

const PlatformSpecificBanner = ({ banners, onBannerClick, screen }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const updateCurrentSlide = (index) => {
    if (currentSlide !== index) {
      setCurrentSlide(index);
    }
  };

  return (
    <div 
      style={{padding: isMobile() ? '20px 0px 0px 0px' : '20px 0px'}} 
      className="home-banners-blk"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Carousel
        showThumbs={false}
        swipeable={true}
        emulateTouch={true}
        swipeScrollTolerance={5}
        infiniteLoop
        selectedItem={currentSlide}
        onChange={updateCurrentSlide}
        showIndicators={false}
        showStatus={false}
        interval={3000}
        transitionTime={450}
        autoPlay={banners?.length >= 1 && !isHovered}
        centerSlidePercentage={!isMobile() ? 100 / 3 : 0}
        centerMode={!isMobile() ? true : false}
        showArrows={!isMobile() ? true : false}
        stopOnHover={true}
        className="banner-carousel"
      >
        {banners.map((banner, i) => {
          return (
            <div
              key={i}
              className="banner-slide"
              style={isMobile() ? {} : { padding: "0 10px" }}
              onClick={() => onBannerClick(banner)}
            >
              <div className="banner-image-container">
                <img 
                  className="banner-image" 
                  src={banner?.image_url} 
                  alt={banner?.title || 'Banner'} 
                />
              </div>
            </div>
          );
        })}
      </Carousel>
      <div className="banners-footer">
        {banners.map((event, index) => {
          return (
            <li
              key={index}
              className={`indicator-banners ${
                currentSlide === index ? "selected-indicator-banners" : ""
              }`}
              onClick={() => {
                updateCurrentSlide(index);
              }}
              onKeyDown={updateCurrentSlide}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PlatformSpecificBanner;
